import emailService from '../../../../services/provider/email'
import erResponseService from '../../../../services/provider/erresponse'
import Vue from 'vue'
import tinymce from 'vue-tinymce-editor'
import { EMAIL_STATUS, ACTION_TYPE } from '../../../../misc/commons'
Vue.component('tinymce', tinymce)
export default {
    data() {
        return {
            item: [],
            items: [],
            admin: [],
            erStatus: EMAIL_STATUS,
            actionType: ACTION_TYPE,
            formType: 'INSERT',
            status: '',
            bodyContent: null,
            footerContent: null,
            comments: '',
            theReplace: null,
            tinyOptions: {
                'height': 280,
                branding: false,
                statusbar: false,
                nonbreaking_force_tab: true,
                indentation: '30pt',
                content_style: 'p {font-size: 16px;color: #666666;font-family: Helvetica,Arial,sans-serif;}',
                setup: function(ed) {
                    ed.on('keydown', function(evt) {
                        if (evt.keyCode == 9){
                            ed.execCommand('mceInsertContent', false, '&emsp;&emsp;&emsp;')
                            evt.preventDefault()
                        }
                    })
                }
            },
        }
    },
    created() {
        this.getEmail('RESPONDER_RECALL_RESPONSE')
    },
    mounted() {
    },
    computed: {
        GetUserRole() {
            return this.$store.state.roleName
        },
    },
    methods: {
        getEmail(type) {
            emailService.getEREmail(type).then(resp => {
                if (!resp.error) {
                    this.items = resp.data.d
                    this.bodyContent = /<body.*?>([\s\S]*)<\/body>/.exec(this.items.content)[1]
                    let htmlSplit = this.bodyContent.split('<p')
                    var htmlStr = ''
                    var footerCnt = 0
                    for (let index = 0; index < htmlSplit.length; index++) {
                        if (htmlSplit[index].includes('Sincerely')) {
                            footerCnt++
                        }
                        if (footerCnt == 0) {
                            htmlStr =  htmlStr + '<p class="mb-0"  style="line-height: 1.4;margin-bottom: 10px !important;color: black;"' + htmlSplit[index]
                        }
                        else
                        {
                            if (htmlSplit[index].includes('Sincerely')) {
                                htmlStr =  htmlStr + '<p class="mb-0" style="color: black;font-weight: 600;padding-bottom: 3px;"' + htmlSplit[index]
                            }
                            else
                            {
                                htmlStr =  htmlStr + '<p class="mb-0" style="color: black;padding-bottom: 3px;"' + htmlSplit[index]
                            }
                        }
                    }
                    this.bodyContent = htmlStr
                    this.bodyContent = this.bodyContent.replace('${SupplierName}','<span style="font-weight: 600;">' + (this.item.suppliername == undefined ? this.item.supplier_name : this.item.suppliername) + '</span>')
                    this.bodyContent= this.bodyContent.replace('${EventName}','<span style="font-weight: 600;">' + (this.item.name == undefined ? this.item.recallname : this.item.name) + '</span>')
                    this.bodyContent = this.bodyContent.replace('${ProviderRole}','<span style="font-weight: 600;">' + this.GetUserRole + '</span>')
                    this.bodyContent = this.bodyContent.replace('${ProviderUserName}','<span style="font-weight: 600;">' + this.admin.name + '</span>')
                    this.bodyContent = this.bodyContent.replace('${ProviderName}','<span style="font-weight: 600;">' + this.admin.companyname + '</span>')
                    this.bodyContent = this.bodyContent.replace('${ProviderUserSite}','<span style="font-weight: 600;">' + this.admin.userSite + '</span>')
                    if (this.item.dataContent== undefined || this.item.dataContent == null) {
                        this.bodyContent = this.bodyContent.replace('<p>${Comments}</p>', '')
                        this.bodyContent = this.bodyContent.replace('<p class="mb-0"  style="line-height: 1.4;margin-bottom: 10px !important;color: black;">${Comments}</p>', '')
                        this.bodyContent = this.bodyContent.replace('${Comments}', ' ')
                    }
                    else if(this.item.status == this.erStatus.SENT && this.item.dataContent != undefined && this.item.dataContent != null)
                    {
                        this.bodyContent = this.bodyContent.replace('${Comments}', JSON.parse(this.item.dataContent).Comments + '</br>')
                    }
                    else
                    {
                        this.bodyContent = this.bodyContent.replace('${Comments}', this.item.dataContent.replace('<p>','').replace('</p>',''))
                    }

                    if (this.admin.title == undefined || this.admin.title == null) {
                        this.bodyContent = this.bodyContent.replace('<p class="mb-0" style="color: black;padding-bottom: 3px;" style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserTitle}</p>', '')
                        this.bodyContent = this.bodyContent.replace('${ProviderUserTitle}', ' ')
                    }
                    else
                    {
                        this.bodyContent = this.bodyContent.replace('${ProviderUserTitle}','<span style="font-weight: 600;">' +  this.admin.title)
                    }

                    if (this.admin.email == undefined || this.admin.email == null) {
                        this.bodyContent = this.bodyContent.replace('<p class="mb-0" style="color: black;padding-bottom: 3px;" style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserEmailAddress}</p>', '')
                        this.bodyContent = this.bodyContent.replace('${ProviderUserEmailAddress}', ' ')
                    }
                    else
                    {
                        this.bodyContent = this.bodyContent.replace('${ProviderUserEmailAddress}', '<span style="font-weight: 600;">' + this.admin.email)
                    }

                    if (this.admin.phoneno == undefined || this.admin.phoneno == null) {
                        this.bodyContent = this.bodyContent.replace('<p class="mb-0" style="color: black;padding-bottom: 3px;" style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserPhoneNumber}</p>', '')
                        this.bodyContent = this.bodyContent.replace('${ProviderUserPhoneNumber}', ' ')
                    }
                    else
                    {
                        var x = this.admin.phoneno.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                        var newvalue = !x[2] ? x[1] :  x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
                        this.bodyContent = this.bodyContent.replace('${ProviderUserPhoneNumber}','<span style="font-weight: 600;">' +  newvalue)
                    }


                    if (this.admin.userSite == undefined || this.admin.userSite == null) {
                        this.bodyContent = this.bodyContent.replace('<p class="mb-0" style="color: black;padding-bottom: 3px;" style="margin-bottom: 0px; margin-top: 0px;">${ProviderUserSite}</p>', '')
                        this.bodyContent = this.bodyContent.replace('${ProviderUserSite}', ' ')
                    }
                    else
                    {
                        this.bodyContent = this.bodyContent.replace('${ProviderUserSite}','<span style="font-weight: 600;">' +  this.admin.userSite)
                    }
                }
            })
        },
        sendEmail(e) {
            let formData = new FormData()
            formData.append('supplierEmail', this.item.response_email == null ? this.item.supplier_email : this.item.response_email)
            formData.append('supplierName', this.item.suppliername == undefined ? this.item.supplier_name : this.item.suppliername)
            formData.append('communicationId', this.item.recallid)
            formData.append('comments', this.comments)
            formData.append('communicationName', this.item.name == undefined ? this.item.recallname : this.item.name)
            this.item.responseCcEmails?.forEach((x, i) => {
                formData.append('supplierRepCCEmails', x)
            })
            this.item.additionalEmailsList?.forEach((x,i)=>
            {
                formData.append('additionalCcEmails', x)
            })
            var RecallId = this.item.responder_recallid == undefined ? this.item.id : this.item.responder_recallid
            erResponseService.sendResponderMail(formData, RecallId).then(resp => {
                if (!resp.error) {
                    this.$refs.modal.hide()
                    this.item.mode = this.actionType.RESPOND
                    this.$emit('onCompleted', this.item)
                }
            })
        },
        forceRerenderInsert(val) {
            this.status = val.status == undefined ? val.response_status : val.status
            this.status = this.status == this.actionType.BOUNCE ? this.actionType.ERROR : this.status
            this.item = val
            if (this.$store.state.user != '') {

                var userData = this.$store.state.user
                this.admin.name = userData.fname + ' ' + userData.lname
                this.admin.email = userData.email
                this.admin.title = userData.title
                this.admin.companyname = userData.org_name
                this.admin.phoneno = userData.phone ?? ''
                this.admin.userSite = (userData.userSite == null || userData.userSite == '') ? userData.location : userData.userSite
            }
            else {
                this.admin.name = ''
                this.admin.email = ''
                this.admin.title = ''
                this.admin.companyname = ''
                this.admin.phoneno = ''
                this.admin.userSite = ''
            }
            this.formType = this.actionType.INSERT
            this.$refs.modal.show()
        },
        cancel() {
            this.$refs.modal.hide()
        }
    }
}